export default __webpack_public_path__ + "static/media/Logo-2do-md-600px.f3a0d7c5.svg";